import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const NotepadIcon = ({ className, fill }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      // strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <path
        opacity="0.2"
        d="M12.5 3V12.5C12.5 12.7652 12.3946 13.0195 12.207 13.207C12.0195 13.3946 11.7652 13.5 11.5 13.5H4.5C4.23478 13.5 3.98051 13.3946 3.79297 13.207C3.60543 13.0195 3.5 12.7652 3.5 12.5V3H12.5Z"
        fill="#2E2E2E"
        stroke="#2E2E2E"
      />
      <path
        d="M6 8H10"
        stroke="#2E2E2E"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 10H10"
        stroke="#2E2E2E"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.5 2.5H12.5C12.6326 2.5 12.7598 2.55268 12.8536 2.64645C12.9473 2.74021 13 2.86739 13 3V12.5C13 12.8978 12.842 13.2794 12.5607 13.5607C12.2794 13.842 11.8978 14 11.5 14H4.5C4.10218 14 3.72064 13.842 3.43934 13.5607C3.15804 13.2794 3 12.8978 3 12.5V3C3 2.86739 3.05268 2.74021 3.14645 2.64645C3.24021 2.55268 3.36739 2.5 3.5 2.5Z"
        stroke="#2E2E2E"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 1.5V3.5"
        stroke="#2E2E2E"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 1.5V3.5"
        stroke="#2E2E2E"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11 1.5V3.5"
        stroke="#2E2E2E"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default NotepadIcon;
